import React from 'react';
import { Box } from '@mui/material';

/**
 * EdgeFadeContainer
 * 좌우 가장자리에 배경색 → 투명 그라데이션 오버레이를 적용해
 * 인접 콘텐츠(예: 라인 그리드 경계선)가 시각적으로 드러나지 않도록 하는 컨테이너
 *
 * Props:
 * @param {number} [fadeWidth=24] - 좌우 그라데이션 너비(px)
 * @param {string} [backgroundColor] - 배경색 (기본: theme.palette.background.default)
 * @param {object} [sx] - 컨테이너 추가 스타일
 */
const EdgeFadeContainer = ({ children, fadeWidth = 24, backgroundColor, sx = {} }) => {
  return (
    <Box
      sx={(theme) => ({
        position: 'relative',
        backgroundColor: backgroundColor || theme.palette.background.default,
        // 오버레이는 컨테이너 내부에서만 동작, 콘텐츠 위로 오지 않도록 z-index 제어
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: fadeWidth,
          pointerEvents: 'none',
          zIndex: 9,
          background: `linear-gradient(to right, ${backgroundColor || theme.palette.background.default} 0%, rgba(0,0,0,0) 100%)`,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          width: fadeWidth,
          pointerEvents: 'none',
          zIndex: 9,
          background: `linear-gradient(to left, ${backgroundColor || theme.palette.background.default} 0%, rgba(0,0,0,0) 100%)`,
        },
        ...sx,
      })}
    >
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        {children}
      </Box>
    </Box>
  );
};

export default EdgeFadeContainer;


